<template>
  <div
    v-if="!isMobile"
    class="product-media__image"
    :style="{ backgroundImage: `url(${getUploadUrl(currentMedia.media.data.attributes.url)})` }"
  ></div>

  <img
    v-if="isMobile"
    ref="imageRef"
    class="product-media__mobile-image"
    :src="getUploadUrl(currentMedia.media.data.attributes.url)"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { StrapiImageMedia } from '@/services/product/types';
import { getUploadUrl } from '@/helpers/urls';
import { useClientSize } from '@/composables/useClientSize';

const props = defineProps<{
  currentMedia: StrapiImageMedia;
}>();

const { isMobile } = useClientSize();

// const { elementRef: imageRef } = useScrollAdjustment();

/* eslint-disable-next-line */
const currentMediaSize = computed(() => {
  const { width, height, size } =
    (props.currentMedia.media &&
      props.currentMedia.media.data &&
      props.currentMedia.media.data.attributes) ||
    {};

  if (width && height) {
    return {
      width: `${width}px`,
      height: `${height}px`
    };
  }

  if (!size) {
    return {
      width: undefined,
      height: undefined
    };
  }

  return {
    width: `${size}px`,
    height: `${size}px`
  };
});
</script>

<style>
.product-media__image {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  max-width: v-bind(currentMediaSize.width);
  max-height: v-bind(currentMediaSize.height);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}

.product-media__mobile-image {
  width: 100%;
  display: block;
}

@media (--mobile) {
}
</style>
